import { Information, Warning } from '@carbon/icons-react';
import classNames from 'classnames';
import * as React from 'react';

import { Icon } from 'bones/design-system/components/icons/Icon';
import { Body } from 'bones/design-system/components/typography/Body';

export interface SystemMessageProps {
  'data-testid'?: never;
  className?: string;
  testId?: string;
  text: React.ReactNode;
  variant: 'alert' | 'info' | 'text';
}

export const SystemMessage: React.VFC<SystemMessageProps> = ({
  className,
  testId,
  text,
  variant,
}) => (
  <div
    className={classNames(
      className,
      'vb-system-message',
      `vb-system-message-variant--${variant}`
    )}
    data-testid={testId}
  >
    <Icon
      IconComponent={variant === 'alert' ? Warning : Information}
      size="2xs"
    />
    <Body size="md">{text}</Body>
  </div>
);
